// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-preview.select-item[data-v-718cc3a7]{border:1px solid #fff;cursor:pointer}", ""]);
// Exports
module.exports = exports;
